module.exports = __webpack_public_path__ + "img/Vector 2.f92be9e6.svg";